export const environment = {
  production: false,
  env: 'Testing',
  HomeTitle: 'MIS Utilitarios - Testing environment',
  ApiUrl: 'https://misutlapitest.clavisco.com/',
  recatpchaSiteKey: '6LcEL_EpAAAAAIvuGfcTDMcVd-DZhRdERKZ3HsB-',
  LogRocketId: ''
};
